'use client'

import { BuilderBlocks } from '@builder.io/react'
import { type ReactNode } from 'react'
import React from 'react'

import {
  type Spacing,
  getInnerSpacingClassNames,
  getOuterSpacingClassNames,
} from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

export type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode[] | ReactNode
  includedChildren?: any[]
  attributes?: any
  innerSpacing?: Spacing
  outerSpacing?: Spacing
  backgroundColor?: string
  backgroundImage?: string
  rounded?: boolean
  includeContentPadding?: boolean
  fill?: boolean
}

export const Container = ({
  className,
  children,
  innerSpacing,
  includedChildren,
  outerSpacing,
  backgroundColor,
  backgroundImage,
  rounded,
  fill,
  includeContentPadding,
  ...props
}: ContainerProps) => {
  const { builderState, builderBlock, attributes, ...containerProps } = props as any
  const shouldRenderBuilderBlocks = () => {
    return !React.Children.count(children)
  }
  const pageMargins = fill ? 'px-0' : 'px-4 sm:px-8 lg:px-16'
  const contentPadding = fill || !includeContentPadding ? 'px-0' : 'px-6 sm:px-8 lg:px-16'
  return (
    <div
      {...attributes}
      key={attributes?.key}
      className={cn(
        'mx-auto w-full max-w-(--breakpoint-2xl)',
        getOuterSpacingClassNames(outerSpacing),
        pageMargins,
        className,
        attributes?.className,
        {
          'max-w-full': fill,
        }
      )}
      style={{ ...attributes?.style }}
      {...containerProps}
      suppressHydrationWarning
    >
      <div
        className={cn(
          'w-full',

          contentPadding,
          getInnerSpacingClassNames(innerSpacing),
          { 'rounded-[30px]': rounded }
        )}
        style={{ backgroundColor }}
      >
        {shouldRenderBuilderBlocks()
          ? includedChildren?.map((child, index) => (
              <BuilderBlocks
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                key={child.item?.[0]?.id || index}
                parentElementId={builderBlock?.id}
                dataPath={`component.options.includedChildren.${index}.item`}
                blocks={child.item}
                style={{ minHeight: 'auto !important' }}
              />
            ))
          : children}
      </div>
    </div>
  )
}
